// Observability bootstrap step.
//
// Wires the native OTel browser SDK (traces + metrics + logs) alongside the
// existing Sentry stack. Run AFTER initSentry so both systems start with the
// same process context. Must run BEFORE app.mount() so the fetch / XHR
// instrumentation is in place before any outbound request is made.
//
// No-ops when VITE_OTEL_EXPORTER_OTLP_ENDPOINT (or the legacy
// VITE_OTEL_OTLP_ENDPOINT) is not set, OR when VITE_OTEL_ENABLED=false —
// safe for local dev without a collector.

import { initOtel } from '@core/observability/otel'

export const initObservability = (): void => {
  initOtel()
}
